import { forwardRef, useState } from 'react'

import { Visibility } from 'globalTypes'

import { Dialog } from '@headlessui/react'
import { Trans } from '@lingui/macro'
import Button from 'Root/App/Button'
import ShareMine from 'Root/App/Item/ShareMine'
import SharePrivate from 'Root/App/Item/SharePrivate'
import ShareWorld from 'Root/App/Item/ShareWorld'
import Title from 'Root/App/Title'

import PanelLayout from '../../PanelLayout'
import styles from './index.module.css'

interface Props {
  visibility: Visibility
  onClose: () => void
  onSave: (visibility: Visibility) => void
}

export type Ref = HTMLDivElement

const Options = ({ visibility, onClose, onSave }: Props) => {
  const [optionSelected, setOptionSelected] = useState(visibility)

  const handleSave = () => {
    onSave(optionSelected)
    onClose()
  }

  const callToActionButtons = (
    <>
      <Button className={styles.choiceCancelButton} onClick={onClose}>
        <Title size="2XS" className={styles.choiceCancelButtonText}>
          <Trans>Annulla</Trans>
        </Title>
      </Button>
      <Button className={styles.choiceSaveButton} onClick={handleSave}>
        <Title size="2XS" className={styles.choiceSaveButtonText}>
          <Trans>Conferma</Trans>
        </Title>
      </Button>
    </>
  )

  return (
    <PanelLayout
      title={<Trans>Condividi</Trans>}
      cta={callToActionButtons}
      onClose={onClose}
    >
      <span className={styles.optionsWrapper}>
        <ShareMine
          active={optionSelected === Visibility.mine}
          onClick={() => setOptionSelected(Visibility.mine)}
        />
        <SharePrivate
          active={optionSelected === Visibility.private}
          onClick={() => setOptionSelected(Visibility.private)}
        />
        <ShareWorld
          active={optionSelected === Visibility.public}
          onClick={() => setOptionSelected(Visibility.public)}
        />
      </span>
    </PanelLayout>
  )
}

const ShareOptions = forwardRef<Ref, Props>(function ShareOptions(
  { visibility, onClose, onSave },
  ref
) {
  return (
    <>
      <Dialog.Panel className={styles.dialogPanel} ref={ref}>
        <Options visibility={visibility} onClose={onClose} onSave={onSave} />
      </Dialog.Panel>
    </>
  )
})

export default ShareOptions
